// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  transition: all 0.5s ease-in-out;
}

.modal-dialog {
  margin: 9.75rem auto !important;
}


.btn-new-secondary {
  color: #515E6C;
  font-weight: bold;
  /* border: 1px solid #ccc; */
}
* {
transition: all 0.2s ease-in-out !important;
}

.form-group label {
 font-weight: 700 !important;
}

.widget-container {
  /* -webkit-transition: 0.5s cubic-bezier(0.41, 0.61, 0.41, 0.95);
  transition: 0.5s cubic-bezier(0.41, 0.61, 0.41, 0.95); */
  width: 100%;
  max-width: 1228px;
    margin: 0 auto;

}


.product-type-image {
  position: absolute;
    width: 64px;
    height: 64px;
    transform: translate(25%, -35%);
    z-index: 2;
}

.get-started-link {
  color: #007bff;
}

.get-started-link:hover {
  color: #007bff !important;
  text-decoration: none;
}
/* .course-container, .course-container .image, .course-container .content, .img-overlay {

} */
.course-container {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 0px 15px #00000033;
  /* max-width: calc(32% - 40px); */
}

.course-container:hover {
  box-shadow: 0px 0px 2px #00000033;
}

.action-buttons button {
  font-size: 18px;
  font-weight: 600;
}

.course-container .image {
  width: 100%;
  min-height: 250px;
  background-size: cover;
  background-repeat: no-repeat;
}

/* .course-container .image>* {
  z-index: 1;
} */

.cut-text {
  display: block!important;
  display: -webkit-box!important;
  -webkit-line-clamp: 2;
  height: 2.45em;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  /* white-space: nowrap; */
}

.course-container .content {
  width: 100%;
  position: relative;
  bottom: 0;
  opacity: 0;
  background-color: #fff;
  transform: translateY(100%);
}


.course-container .content.show {
  transform: translateY(0) !important;
  opacity: 1;
}

.init-title {
  opacity: 1;
}

.init-title.hide {
  opacity: 0;
}

#progressbar {
  background-color: #EAEAEA;
  /* border-radius: 13px; */
  /* (height of inner div) / 2 + padding */
  padding: 0px;
  border-radius: 50px;
}

#progressbar>div {
  background-color: #0078FF;
  width: 0%;
  border-radius: 50px;
  /* Adjust with JavaScript */
  height: 5px;
}


/* Dashboard Cards */

.flexgrid {
  flex-flow: wrap;
}
.flexcol{
 float: left;
 /* width: 29.33%; */
 width: calc(29.3%);
  margin: 2%;
}

.top-image-bg>* {
  z-index: 1 !important;
}
.img-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top:0;
  left: 0;
  background-color: #00000080;
  z-index: 0;
}
/* .newflexcol{
  display: inline-block;
  float: left;
  width: 29.33%;
  border-radius: 5px;
  margin: 2%;
  text-align: center;
  border: dashed 2px #cccccc;
  background-color: #fff;
  transition: all 0.5s cubic-bezier(0.41, 0.61, 0.41, 0.95);
  cursor: pointer;
 } */

 @media screen and (max-width: 900px) {
  .newflexcol,.flexcol{width: 100%;}
  .cards {
    padding: 0;
  }

}

@media screen and (min-width:900px) and (max-width: 1024px) {
  .newflexcol,.flexcol{width: 46%;}

}


.sticky-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}


::ng-deep router-outlet.router-flex + * {
height: 100%;
overflow-x: hidden !important;
overflow-y: hidden;

}


/* Set the initial state of the element */
.wizard-container > * {

}

/* Define the keyframes for the animation */
/* @keyframes expand {
  0% { max-height: 0; }
  100% { max-height: 1000px; }
} */

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/user-dashboard/product/create/product-create-wizard/product-create-wizard.component.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;AACA,2CAA2C;AAC3C;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;EACE;0DACwD;EACxD,WAAW;EACX,iBAAiB;IACf,cAAc;;AAElB;;;AAGA;EACE,kBAAkB;IAChB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,UAAU;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;GAEG;AACH;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;GAEG;;AAEH;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,2BAA2B;AAC7B;;;AAGA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;;AAGA,oBAAoB;;AAEpB;EACE,eAAe;AACjB;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,kBAAkB;EACjB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,KAAK;EACL,OAAO;EACP,2BAA2B;EAC3B,UAAU;AACZ;AACA;;;;;;;;;;;IAWI;;CAEH;EACC,qBAAqB,WAAW,CAAC;EACjC;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE,qBAAqB,UAAU,CAAC;;AAElC;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;;AAGA;AACA,YAAY;AACZ,6BAA6B;AAC7B,kBAAkB;;AAElB;;;AAGA,yCAAyC;AACzC;;AAEA;;AAEA,2CAA2C;AAC3C;;;GAGG;;AAEH,w7NAAw7N","sourcesContent":["* {\n  transition: all 0.5s ease-in-out;\n}\n\n.modal-dialog {\n  margin: 9.75rem auto !important;\n}\n\n\n.btn-new-secondary {\n  color: #515E6C;\n  font-weight: bold;\n  /* border: 1px solid #ccc; */\n}\n* {\ntransition: all 0.2s ease-in-out !important;\n}\n\n.form-group label {\n font-weight: 700 !important;\n}\n\n.widget-container {\n  /* -webkit-transition: 0.5s cubic-bezier(0.41, 0.61, 0.41, 0.95);\n  transition: 0.5s cubic-bezier(0.41, 0.61, 0.41, 0.95); */\n  width: 100%;\n  max-width: 1228px;\n    margin: 0 auto;\n\n}\n\n\n.product-type-image {\n  position: absolute;\n    width: 64px;\n    height: 64px;\n    transform: translate(25%, -35%);\n    z-index: 2;\n}\n\n.get-started-link {\n  color: #007bff;\n}\n\n.get-started-link:hover {\n  color: #007bff !important;\n  text-decoration: none;\n}\n/* .course-container, .course-container .image, .course-container .content, .img-overlay {\n\n} */\n.course-container {\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0px 0px 15px #00000033;\n  /* max-width: calc(32% - 40px); */\n}\n\n.course-container:hover {\n  box-shadow: 0px 0px 2px #00000033;\n}\n\n.action-buttons button {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.course-container .image {\n  width: 100%;\n  min-height: 250px;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n/* .course-container .image>* {\n  z-index: 1;\n} */\n\n.cut-text {\n  display: block!important;\n  display: -webkit-box!important;\n  -webkit-line-clamp: 2;\n  height: 2.45em;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  /* white-space: nowrap; */\n}\n\n.course-container .content {\n  width: 100%;\n  position: relative;\n  bottom: 0;\n  opacity: 0;\n  background-color: #fff;\n  transform: translateY(100%);\n}\n\n\n.course-container .content.show {\n  transform: translateY(0) !important;\n  opacity: 1;\n}\n\n.init-title {\n  opacity: 1;\n}\n\n.init-title.hide {\n  opacity: 0;\n}\n\n#progressbar {\n  background-color: #EAEAEA;\n  /* border-radius: 13px; */\n  /* (height of inner div) / 2 + padding */\n  padding: 0px;\n  border-radius: 50px;\n}\n\n#progressbar>div {\n  background-color: #0078FF;\n  width: 0%;\n  border-radius: 50px;\n  /* Adjust with JavaScript */\n  height: 5px;\n}\n\n\n/* Dashboard Cards */\n\n.flexgrid {\n  flex-flow: wrap;\n}\n.flexcol{\n float: left;\n /* width: 29.33%; */\n width: calc(29.3%);\n  margin: 2%;\n}\n\n.top-image-bg>* {\n  z-index: 1 !important;\n}\n.img-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top:0;\n  left: 0;\n  background-color: #00000080;\n  z-index: 0;\n}\n/* .newflexcol{\n  display: inline-block;\n  float: left;\n  width: 29.33%;\n  border-radius: 5px;\n  margin: 2%;\n  text-align: center;\n  border: dashed 2px #cccccc;\n  background-color: #fff;\n  transition: all 0.5s cubic-bezier(0.41, 0.61, 0.41, 0.95);\n  cursor: pointer;\n } */\n\n @media screen and (max-width: 900px) {\n  .newflexcol,.flexcol{width: 100%;}\n  .cards {\n    padding: 0;\n  }\n\n}\n\n@media screen and (min-width:900px) and (max-width: 1024px) {\n  .newflexcol,.flexcol{width: 46%;}\n\n}\n\n\n.sticky-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  background-color: #fff;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n\n::ng-deep router-outlet.router-flex + * {\nheight: 100%;\noverflow-x: hidden !important;\noverflow-y: hidden;\n\n}\n\n\n/* Set the initial state of the element */\n.wizard-container > * {\n\n}\n\n/* Define the keyframes for the animation */\n/* @keyframes expand {\n  0% { max-height: 0; }\n  100% { max-height: 1000px; }\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
